exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-input input.el-input__inner {\n  border-radius: 5px;\n}", "", {"version":3,"sources":["/var/www/html/brkt/src/app/components/Approval.vue"],"names":[],"mappings":"AACA;EACE,mBAAA;CAAF","file":"Approval.vue?vue&type=style&index=0&id=0e22a785&lang=scss","sourcesContent":["\n.el-input input.el-input__inner {\n  border-radius: 5px;\n}\n\n\n"],"sourceRoot":""}]);

// exports
